/**
 * PublicOnlyRoute — guard для публичных auth-страниц
 * (welcome, sign-in, sign-up, forgot-password).
 *
 * Если юзер уже авторизован — редиректит на главную, чтобы залогиненный
 * не мог случайно увидеть форму входа.
 *
 * Исключение: /reset-password — эта страница должна работать даже при
 * активной recovery-сессии. Для неё используется отдельный RecoveryRoute.
 */

import { Navigate, Outlet } from 'react-router';
import { useCurrentUser } from '@/features/user';
import { Spinner } from '@/components/ui/spinner';
import { ROUTE_PATHS } from '@/lib';

export function PublicOnlyRoute(): JSX.Element {
  const { data: user, isLoading } = useCurrentUser();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-screen bg-background">
        <Spinner className="size-16" />
      </div>
    );
  }

  if (user) {
    return <Navigate to={ROUTE_PATHS.HOME_FEED} replace />;
  }

  return <Outlet />;
}
